import { render, staticRenderFns } from "./CreateDepartmentModal.vue?vue&type=template&id=e52ad180&scoped=true"
import script from "./CreateDepartmentModal.vue?vue&type=script&lang=js"
export * from "./CreateDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateDepartmentModal.vue?vue&type=style&index=0&id=e52ad180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52ad180",
  null
  
)

export default component.exports